import React from "react";
import Header from "../components/Header";
import { Link } from "react-router-dom";
import { BsChevronDown, BsChevronUp } from "react-icons/bs";
import { useTranslation } from 'react-i18next';


export default function NoticeView() {
    const { t } = useTranslation();

    return (
        <div>
            <Header type="black" pageTitle={t(`Message.notice_bbs_list_title`)}/>
            <div className="noticeViewTitWr">
                <p className="tit">고객센터 전화상담 및 일부 서비스 일시 중단 안내 (5월 13일)</p>
                <p className="date">2024-01-20</p>
            </div>
            <div className="noticeArea">
                <p>
                    사회적 특수계급의 제도는 인정되지 아니하며, 
                    어떠한 형태로도 이를 창설할 수 없다. 행정각부의
                    장은 국무위원 중에서 국무총리의 제청으로 대통령이 임명한다.
                    훈장등의 영전은 이를 받은 자에게만 효력이 있고, 
                    어떠한 특권도 이에 따르지 아니한다. 
                    국회는 의장 1인과 부의장 2인을 선출한다.
                    모든 국민은 인간다운 생활을 할 권리를 가진다.

                    재판의 전심절차로서 행정심판을 할 수 있다. 
                    행정심판의 절차는 법률로 정하되, 사법절차가 준용되어야 한다.
                    국가는 평생교육을 진흥하여야 한다.
                    국회의원은 법률이 정하는 직을 겸할 수 없다.
                    국가는 농지에 관하여 경자유전의 원칙이 달성될 수 있도록 노력하여야 하며,
                    농지의 소작제도는 금지된다.

                    제2항의 재판관중 3인은 국회에서 선출하는 자를, 
                    3인은 대법원장이 지명하는 자를 임명한다. 
                    외국인은 국제법과 조약이 정하는 바에 의하여 그 지위가 보장된다. 
                    국무총리는 국회의 동의를 얻어 대통령이 임명한다. 
                    대법관의 임기는 6년으로 하며, 
                    법률이 정하는 바에 의하여 연임할 수 있다. 
                    국가는 모성의 보호를 위하여 노력하여야 한다.
                </p>

                <Link to="/Notice" className="btn40 bdd fw600 mt40">{t(`Message.notice_bbs_list_move_list`)}</Link>
            </div>
            <div className="pnBtnWr">
                <Link to="" className="pnBtn">
                    <p className="tag">이전글 <BsChevronUp /></p>
                    <p className="notiTitle">쇼핑몰 공지사항입니다.</p>
                </Link>
                <Link to="" className="pnBtn">
                    <p className="tag">다음글 <BsChevronDown /></p>
                    <p className="notiTitle">2024년 추석연휴 배송안내 2024년 추석연휴 배송안내 2024년 추석연휴 배송안내 추석연휴 배송안내</p>
                </Link>
            </div>
        </div>
    );
};